import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { PROFITABILITY_PATH } from "@/profitability/routes";
export const BackToReports = () => (
  <Link
    to={PROFITABILITY_PATH}
    className="flex w-fit items-center gap-1.5 text-sm text-secondary-text hover:text-primary-text"
  >
    <ArrowLeftIcon className="h-3.5 w-3.5" />
    Profitability
  </Link>
);
